import React from 'react';
import { assets } from '../assets/assets';
import { IoMdClose } from "react-icons/io";

const VideoCollection = () => {
  return (
    <div className='video-section'>
      {/* video-section */}

<div className="watch_video py-2 ">
        <div className="container">
            <div className="text-center">
                <button type="button" className="how_donate bg-transparent text-dark border-0" data-bs-toggle="modal"
                    data-bs-target="#donateModal">
                    <img src={assets.youtube_icon} className="img-fluid" alt="Watch"/> 
                     How to Donate? watch Now!
                </button>
            </div>
        </div>
    </div>
    <div className="modal fade" id="donateModal" tabIndex="-1" aria-labelledby="donateModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content bg-transparent rounded-4 border-0">
                <div className="modal-header border-0">
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <IoMdClose />
                    </button>
                </div>
                <div className="modal-body p-0">
                    <div className="ratio ratio-16x9">
                       <iframe
                        className="w-100 rounded-4"
                        src="https://www.youtube.com/embed/hAP2QF--2Dg?si=sF8xL9HMWj1MuIgg"
                        title="YouTube video player"
                        frameBorder="0"
                        allow=" web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                      ></iframe>

                    </div>
                </div>
            </div>
        </div>
    </div>
    {/* video-section-end */}
    </div>
  )
}

export default VideoCollection
